import { FC, memo } from 'react'

import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter: FC = memo(() => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { relationshipOptions, form } = data

  const formApi = useForm({
    defaultValues: {
      adverseMediaCompanyID: form.adverseMediaCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        adverseMediaCompanyID: undefined,
        adverseMediaPage: 1
      },
      'adverseMedia'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, adverseMediaPage: 1 }, 'adverseMedia')
  }

  const hasActiveFilters = Boolean(search.adverseMediaCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <SC.FormWrapper>
        <SC.FilterWrapper>
          <SC.ItemWrapper>
            <formApi.Field
              name="adverseMediaCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ adverseMediaCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationships"
                  input={(inputProps) => (
                    <CompanySelect hideMyCompaniesFilter preloadedOptions={relationshipOptions} {...inputProps} />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
        </SC.FilterWrapper>
      </SC.FormWrapper>
    </FilterPanel>
  )
})
